// Webpack Imports
import 'bootstrap';
import 'slick-carousel';
import './home';
import './animations';
import './forms';
import './maps';
import './slick';

( function ( jQuery ) {

  // Focus Search if Searchform is empty
	jQuery( '.search-form' ).on( 'submit', function ( e ) {
		var search = jQuery( '#s' );
		if ( search.val().length < 1 ) {
			e.preventDefault();
			search.trigger( 'focus' );
		}
	} );

  // Adds Flex Video to YouTube and Vimeo Embeds
  jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').addClass('embed-responsive-item').wrap("<div class='embed-responsive embed-responsive-16by9'/>");

  const $mainNavbar = jQuery('.main-navbar');
  const $navbarToggler = jQuery('.main-navbar .navbar-toggler');
  const $navbarCollapse = jQuery('.main-navbar .navbar-collapse');

  $navbarToggler.on('click', () => {
    $mainNavbar.toggleClass('open');
    $navbarToggler.toggleClass('collapsed')
    $navbarCollapse.toggleClass('show');
  });

}( jQuery ) );
